import React from 'react';
import logo from './logo.svg';
import './App.css';
import Main from './components/Main'
import Navbar from './components/Navbar';

function App() {
  return (
    <div id='App'>
      <Navbar/>
      <Main/>
      {/* <Footer/> */}
    </div>
  );
}

export default App;
